module.exports = __webpack_public_path__ + "static/media/23.f2724253.wav";